import { get } from '../tools/http';

const SC = [
    {
        keys: ['проект', 'проекты'],
        item: {
            route: { name: 'competitions', params: { type: 'project'} },
            text: 'Перейти на страницу проектов',
            title: 'Проекты',
        },
    },
    {
        keys: ['тест', 'тесты'],
        item: {
            route: { name: 'testingPreList' },
            text: 'Перейти на страницу тестов',
            title: 'Тесты',
        },
    },
    {
        keys: ['курс', 'курсы'],
        item: {
            route: { name: 'events', params: { type: 'courses' } },
            text: 'Перейти на страницу курсов',
            title: 'Курсы',
        },
    },
    {
        keys: ['компетенция', 'компетенции'],
        item: {
            route: { name: 'competences' },
            text: 'Перейти на страницу компетенций',
            title: 'Компетенции',
        },
    },
    {
        keys: ['диагностика'],
        item: {
            route: { name: 'track' },
            text: 'Перейти на страницу диагностики',
            title: 'Диагностика',
        },
    },
    {
        keys: ['контакт', 'контакты', 'телефон', 'поддержка', 'связаться', 'сми', 'пользовательское соглашение', 'документы'],
        item: {
            route: { name: 'contacts' },
            text: 'Перейти на страницу контактов',
            title: 'Контакты',
        },
    },
    {
        keys: ['новость', 'новости'],
        item: {
            route: { name: 'news' },
            text: 'Перейти на страницу новостей',
            title: 'Новости',
        },
    },
    {
        keys: ['история успеха', 'истории успеха'],
        item: {
            route: { name: 'success' },
            text: 'Перейти на страницу историй успеха',
            title: 'Истории успеха',
        },
    },
    // {
    //     keys: ['помощь другим', 'помощи другим'],
    //     item: {
    //         link: (domain) => `https://${domain}/portal/main/gains`,
    //         text: 'Перейти на страницу помощи другим',
    //         title: 'Помощь другим',
    //     },
    // },
    {
        keys: ['наставничество'],
        item: {
            route: { name: 'mentoring' },
            text: 'Перейти на страницу программы "Наставничество"',
            title: 'Наставничество',
        },
    },
    {
        keys: ['команда'],
        item: {
            route: { name: 'about-team' },
            text: 'Перейти на страницу нашей команды',
            title: 'Команда',
        },
    },
    // {
    //     keys: ['сенеж'],
    //     item: {
    //         link: 'portal/competitions/events/1/27/?mView=detail',
    //         text: 'Сенеж',
    //         title: 'Сенеж',
    //     },
    // },
    {
        keys: ['статистика', 'цифры'],
        item: {
            route: { name: 'about-us' },
            text: 'Автономная некоммерческая организация, созданная в 2018 году по инициативе Президента России Владимира Путина',
            title: 'О нас',
        },
    },
    {
        keys: ['наблюдательный совет'],
        item: {
            route: { name: 'supervisory-board' },
            text: 'Перейти на страницу наблюдательного совета',
            title: 'Наблюдательный совет',
        },
    },
    {
        keys: ['блог', 'блоги'],
        item: {
            link: domain => `https://${domain}/blog/`,
            text: 'Перейти на страницу блога',
            title: 'Блог',
        },
    },
    {
        keys: ['галерея', 'фотогалерея'],
        item: {
            route: { name: 'galleries' },
            text: 'Перейти на страницу галереи',
            title: 'Фотогалерея',
        },
    },
];

const createParser = affiliation => {
    return item => {
        let date = item.created_at || null;
        switch (affiliation) {
            case 'course': return {
                title: item.theme,
                text: item.description,
                date: date,
            };
            case 'page': return {
                title: item.name || item.title,
                text: item.data || item.text,
                date: date,
            };
            case 'session': return {
                title: item.theme,
                text: item.description,
                date: date,
            };
            default: return { ...item, date: date };
        }
    };
};

const createUrlMaker = affiliation => {
    switch (affiliation) {
        case 'testing':
            return item => ({ route: {
                name: 'testingDetail',
                params: { testId: item.id },
            }});
        case 'success_story':
            return item => ({ route: {
                name: 'success',
                params: { page: 1, id: item.id },
                query: { mView: 'detail' },
            }});
        case 'gallery':
            return item => ({ route: {
                name: 'gallery',
                params: { page: 1, id: item.id },
            }});
        // case 'event_fulltime':
        //     return item => ({
        //         name: 'competitions-events-page-id',
        //         params: { page: 1, item.id },
        //         query: { mView: 'detail' },
        //     });
        case 'blogs':
            return item => ({ link: domain => `https://${domain}/blog/${item.slug}` });
        case 'news':
            return item => ({ route: {
                name: 'news',
                params: { page: 1, id: item.id },
                query: { mView: 'detail' },
            }});
        case 'progress_soft_skills':
            return item => ({ route: {
                name: 'competence',
                params: { id: item.id },
            }});
        case 'projects_spk2':
            return item => ({ route: {
                name: 'competitions',
                params: { type: 'project', page: 1, id: item.publication_id },
            }});
        case 'course':
            return item => ({ route: {
                name: 'events',
                params: { type: 'courses', page: 1, id: item.id },
                query: { mView: 'detail' },
            }});
        case 'mentoring':
            return item => ({ route: {
                name: 'mentoring',
            }});
        case 'page':
            return item => ({ route: {
                name: 'about-us',
            }});
        default:
            return () => ({ route: {
                path: '#',
            }});
    }
};

const flatten = obj => {
    const results = [];

    for (const affiliation in obj) {
        if (!obj.hasOwnProperty(affiliation)) continue;
        if (!obj[affiliation].length) continue;

        const makeUrl = createUrlMaker(affiliation);
        const parser = createParser(affiliation);

        const process = item => {
            const route = makeUrl(item);
            const { title, text, date } = parser(item);

            const result = {
                title,
                text,
                ...route,
                affiliation,
                date,
            };

            results.push(result);
        };

        obj[affiliation].forEach(process);
    }

    return results;
};

const searchInSC = (str) => {
    // вариант поиска с сортировкой по первому совпадению
    return SC
        .map(v => {
            let sort = Number.MAX_VALUE;
            v.keys.forEach(key => {
                let index = key.indexOf(str.toLowerCase().trim());
                if (index < sort && index > -1) sort = index;
            });
            return { ...v, sort: sort };
        })
        .filter(v => v.sort < Number.MAX_VALUE)
        .sort((a, b) => a.sort - b.sort)
        .map(v => v.item);

    // облегченный вариант поиска
    // return SC.filter(v => v
    //     .keys
    //     .filter(key => key.indexOf(str.toLowerCase().trim()) >= 0).length > 0
    // ).map(v => v.item);
};

export default {
    state: {
        items: [],
        received: false,
    },
    mutations: {
        writeItems: (state, items) => state.items = items,
        clearSearch: state => state.items = [],
        setReceived: (state, value) => state.received = value,
    },
    actions: {
        searchText: async (ctx, { str, filters = '' }) => {
            let result = [];
            try {
                result = await get('search', 'search?q=' + encodeURIComponent(str) + filters);
            } catch (e) {
                result = [];
            }

            let flat = flatten(result);

            const searchResultsInSC = searchInSC(str);
            if (searchResultsInSC.length > 0) {
                flat = [...searchResultsInSC, ...flat];
            }
            ctx.commit('writeItems', flat);
            ctx.commit('setReceived', true);
        },
        setReceived: (ctx, value) => ctx.commit('setReceived', value),
        clearSearch: ctx => {
            ctx.commit('clearSearch');
            ctx.commit('setReceived', false);
        },
    },
    getters: {
        searchItems: state => state.items,
        searchCount: state => state.items.length,
        searchReceived: state => state.received,
    },
};
